












import Vue from 'vue';
import Component from 'vue-class-component';
import vueDropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';

const FileUploadProps = Vue.extend({
  props: {
    id: {
      type: String,
      default: 'dropzone',
    },
  },
});

@Component({
  name: 'FileUpload',

  components: {
    vueDropzone,
  },

  data() {
    return {
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 100,
        thumbnailHeight: 75,
        maxFilesize: 25, // MB
        parallelUploads: 2,
        maxFiles: 20,
        headers: {},
        addRemoveLinks: true,
        dictDefaultMessage: 'Sleep bestanden of klik om bestanden toe te voegen',
        dictCancelUploadConfirmation: 'Weet je zeker dat je de upload wil stoppen?',
        dictCancelUpload: 'Annuleer',
        dictRemoveFile: 'Verwijder',
      },
    };
  },
})
export default class FileUpload extends FileUploadProps {
  uploadState = 'idle';

  files: Array<string> = [];

  getFilesInProgress() {
    const dropzone: any = this.$refs.vueDropzone;
    const queuedFiles: Array<object> = dropzone.getQueuedFiles();
    const uploadingFiles: Array<object> = dropzone.getUploadingFiles();

    return [...queuedFiles, ...uploadingFiles];
  }

  onFilesAdded() {
    this.uploadState = 'uploading';

    this.$emit('added');
  }

  onUploadComplete() {
    this.uploadState = 'complete';

    this.$emit('complete');
  }

  onError() {
    this.uploadState = 'error';

    this.$emit('error');
  }

  onUploadSuccess(file: any) {
    const fileName: string = file.name;

    // TODO: Use URL
    this.files.push(fileName);

    this.$emit('input', this.files);
  }
}
